import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { EnvironmentconfigService } from 'src/app/shared/service/environmentconfig.service';
import { JsMenu } from '../../models/layout-model';
import { AppConfigService } from 'src/app/shared/service/app-config.service';
import { AuthService } from 'src/app/shared/auth/auth.service';

@Component({
  selector: 'app-side-navbar',
  templateUrl: './side-navbar.component.html',
  styleUrls: ['./side-navbar.component.scss']
})
export class SideNavbarComponent implements OnInit {
  version = '--';
  menus: JsMenu[] = [];
  isSmallScreen: boolean = false;
  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.isSmallScreen = window.innerWidth <= 768;
  }
  currentEnvironment = '';
  mvmSiteNew = '';
  @Input() isCollapsed: boolean = false;

  constructor(private EnvironmentconfigService: EnvironmentconfigService,
    private router: Router, private appConfigService: AppConfigService,
    private authServ: AuthService
  ) { }

  ngOnInit(): void {
    this.currentEnvironment = this.appConfigService.getActualConfig('env_type');
    this.mvmSiteNew = this.EnvironmentconfigService.authConfig.MVMSiteNew;

    this.authServ.handleMenus().subscribe(
      {
        next: () => {
          this.initMenu();
        },
        error: (error) => {
          console.error('Error loading menus:', error);
          this.initMenu();
        }
      }
    );
  }
  initMenu() {
    // 从 localStorage 中获取 'DisplayMenus'
    this.menus = localStorage.getItem('DisplayMenus') ? JSON.parse(localStorage.getItem('DisplayMenus')) : [];

    const findAndSetMenuState = (menus) => {
      for (const menu of menus) {
        // 检查当前菜单的 tCode 是否匹配（如果匹配就打开）
        if (menu.tCode === this.router.url) {
          menu.isOpen = true;
          return true;
        }

        if (menu.childMenus && menu.childMenus.length > 0) {
          if (findAndSetMenuState(menu.childMenus)) {
            menu.isOpen = true;
            return true;
          }
        }
      }
      return false;
    };

    findAndSetMenuState(this.menus);
  }


  OpenChange(menuId: string, event: boolean) {
    if (event && menuId) {
      if (this.menus.findIndex(x => x.menuId == menuId) != -1) {
        for (let index = 0; index < this.menus.length; index++) {
          const firstMenu = this.menus[index];
          if (firstMenu.menuId == menuId) {
            this.menus[index].isOpen = event
          } else {
            this.menus[index].isOpen = !event
          }
        }
      }
    }
  }
  GoPage() {
    this.router.navigate(['/pages']);
  }
}
